import { render, staticRenderFns } from "./CasesView.vue?vue&type=template&id=2007f502&scoped=true&"
import script from "./CasesView.vue?vue&type=script&lang=js&"
export * from "./CasesView.vue?vue&type=script&lang=js&"
import style0 from "./CasesView.vue?vue&type=style&index=0&id=2007f502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007f502",
  null
  
)

export default component.exports